"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGridColumnFromCrossTable = exports.isGridColumnOfType = exports.dateFilterComparator = exports.dateComparator = exports.isDuplicate = exports.nonNullBooleanValueSetter = exports.booleanValueSetter = exports.eanValueSetter = exports.bksValueSetter = exports.numericValueSetter = exports.clearCells = exports.onCellKeyDown = void 0;
const core_1 = require("@ag-grid-community/core");
const utils_1 = require("./utils");
const errorNotification_1 = require("../errorNotification");
function onCellKeyDown(e) {
    // @ts-ignore
    let keyPress = e.event.keyCode;
    e.event.stopPropagation();
    if (keyPress === 46) {
        e.api.stopEditing(true);
        // raise fill event, important for undoredo stack
        const fillStartEvent = {
            type: core_1.Events.EVENT_FILL_START,
            columnApi: e.columnApi,
            api: e.api,
        };
        e.api.dispatchEvent(fillStartEvent);
        let cellRanges = e.api.getCellRanges();
        cellRanges.forEach(cells => {
            let colIds = cells.columns.map(col => col.getColId());
            // @ts-ignore
            let startRowIndex = Math.min(cells.startRow.rowIndex, cells.endRow.rowIndex);
            // @ts-ignore
            let endRowIndex = Math.max(cells.startRow.rowIndex, cells.endRow.rowIndex);
            clearCells(e.api, startRowIndex, endRowIndex, cells.columns);
        });
        const fillEndEvent = {
            type: core_1.Events.EVENT_FILL_END,
            columnApi: e.columnApi,
            api: e.api,
            initialRange: cellRanges[0],
            finalRange: cellRanges[0],
        };
        e.api.dispatchEvent(fillEndEvent);
        const focused = e.api.getFocusedCell();
        e.api.setFocusedCell(focused.rowIndex, focused.column.getColId());
    }
}
exports.onCellKeyDown = onCellKeyDown;
function clearCells(api, start, end, columns) {
    for (let i = start; i <= end; i++) {
        let rowNode = api.getDisplayedRowAtIndex(i);
        columns.forEach(column => {
            if (column.isCellEditable(rowNode))
                rowNode.setDataValue(column.getColId(), null);
        });
    }
}
exports.clearCells = clearCells;
function numericValueSetter(transformNumber) {
    return (params) => {
        let { newValue } = params;
        if ((0, utils_1.isNumber)(newValue)) {
            newValue = transformNumber ? transformNumber(newValue) : newValue;
            params.data[params.column.getColId()] = newValue;
            return true;
        }
        if (newValue === null || newValue === '' || newValue === undefined) {
            params.data[params.column.getColId()] = null;
            return true;
        }
        (0, errorNotification_1.notify)('error', 'Es sind nur Zahlen erlaubt');
        return false;
    };
}
exports.numericValueSetter = numericValueSetter;
function bksValueSetter() {
    return (params) => {
        let { newValue, oldValue } = params;
        if (newValue == oldValue)
            return false;
        if (newValue === null || newValue === '' || newValue === undefined) {
            params.data[params.column.getColId()] = null;
            return true;
        }
        if (!(0, utils_1.isNumber)(newValue)) {
            (0, errorNotification_1.notify)('error', 'Es sind nur Zahlen erlaubt');
            return false;
        }
        if (isDuplicate(params.api, newValue, params.column.getColId())) {
            return false;
        }
        params.data[params.column.getColId()] = newValue;
        return true;
    };
}
exports.bksValueSetter = bksValueSetter;
function eanValueSetter() {
    return (params) => {
        let { newValue, oldValue } = params;
        if (newValue == oldValue)
            return false;
        if (newValue === null || newValue === '' || newValue === undefined) {
            params.data[params.column.getColId()] = null;
            return true;
        }
        if (isDuplicate(params.api, newValue, params.column.getColId())) {
            return false;
        }
        params.data[params.column.getColId()] = newValue;
        return true;
    };
}
exports.eanValueSetter = eanValueSetter;
function booleanValueSetter() {
    return (params) => {
        let { newValue } = params;
        if ((0, utils_1.isNumber)(newValue)) {
            params.data[params.column.getColId()] = (newValue == 1) ? 1 : null;
            return true;
        }
        if (newValue === null || newValue === '' || newValue === undefined) {
            params.data[params.column.getColId()] = null;
            return true;
        }
        (0, errorNotification_1.notify)('error', 'Es ist nur “1” oder kein Eintrag erlaubt');
        return false;
    };
}
exports.booleanValueSetter = booleanValueSetter;
// sets boolean values as 1 or 0, not NULL
const nonNullBooleanValueSetter = (params) => {
    let { newValue } = params;
    if ((0, utils_1.isNumber)(newValue)) {
        params.data[params.column.getColId()] = (newValue == 1) ? 1 : 0;
        return true;
    }
    if (newValue === null || newValue === '' || newValue === undefined) {
        params.data[params.column.getColId()] = 0;
        return true;
    }
    (0, errorNotification_1.notify)('error', 'Es ist nur “1”, “0” oder kein Eintrag erlaubt');
    return false;
};
exports.nonNullBooleanValueSetter = nonNullBooleanValueSetter;
function isDuplicate(api, value, columnId) {
    if (value === null || value === '') {
        return false;
    }
    let duplicateDetected = false;
    api.forEachNode((node) => {
        if (node.data[columnId] == value) {
            duplicateDetected = true;
        }
    });
    if (!duplicateDetected) {
        return false;
    }
    return !confirm(`Der Wert ${value}  ist bereits vorhanden. Sind Sie sicher?`);
}
exports.isDuplicate = isDuplicate;
// date comparator for sorting date fields, works only for dates in d.m.y. format
function dateComparator(date1, date2) {
    var date1Number = (0, utils_1.dateToNumber)(date1);
    var date2Number = (0, utils_1.dateToNumber)(date2);
    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }
    return date1Number - date2Number;
}
exports.dateComparator = dateComparator;
function dateFilterComparator(filterLocalDateAtMidnight, cellValue) {
    var dateAsString = cellValue;
    if (dateAsString == null)
        return -1;
    var dateParts = dateAsString.split('.');
    var day = Number(dateParts[0]);
    // -1 Date object indexes months from 0
    var month = Number(dateParts[1]) - 1;
    var year = Number(dateParts[2]);
    var cellDate = new Date(year, month, day);
    if (cellDate < filterLocalDateAtMidnight) {
        return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
        return 1;
    }
    // filterLocalDateAtMidnight.getTime() === cellDate.getTime()
    return 0;
}
exports.dateFilterComparator = dateFilterComparator;
;
function isGridColumnOfType(column, type) {
    const columnType = column.getColDef().type;
    if (!columnType)
        return false;
    const haystack = Array.isArray(columnType)
        ? columnType
        : columnType.split(",").map(i => i.trim());
    return haystack.includes(type.trim());
}
exports.isGridColumnOfType = isGridColumnOfType;
// Checks if the column is a cross table column using the column field name
function isGridColumnFromCrossTable(column, gridTable) {
    const columnField = column.getColDef().field;
    if (!columnField)
        return false;
    return columnField.includes('@' + gridTable);
}
exports.isGridColumnFromCrossTable = isGridColumnFromCrossTable;
